export const Markets = [
    "AT",
    "DE",
    "FR",
    "IT",
    "ES",
]